<template>
  <l-layout :layout="['xs12']">
    <v-form ref="deviceForm">
      <v-card class="pa-3">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field v-model="form.name" prepend-icon="$vuetify.icons.title" label="控制器名称" :disabled="disabledFlag"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-text-field label="sn" prepend-icon="$vuetify.icons.code" v-model="form.sn" :disabled="disabledFlag"></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-btn color="primary" flat @click="autoGenerateSn">自动生成sn</v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-text-field label="secret" prepend-icon="$vuetify.icons.code" v-model="form.secret" :disabled="disabledFlag"></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-btn color="primary" flat @click="autoGenerateSecret">自动生成secret</v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <l-autocomplete
                :get-data="getGateByName"
                item-text="name"
                label="关联卡口选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.gate"
                :disabled="disabledFlag"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs6>
              <l-autocomplete
                :get-data="getServiceByName"
                item-text="name"
                label="所属硬件服务"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.service"
                :disabled="disabledFlag"
              ></l-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea label="控制器描述" prepend-icon="$vuetify.icons.comment" rows="1" auto-grow :disabled="disabledFlag"></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs2>
              <v-text-field label="显示屏显示行数" prepend-icon="$vuetify.icons.code" v-model="form.ledRows" :disabled="disabledFlag"></v-text-field>
            </v-flex>
            <v-flex xs10 >
              <v-text-field label="显示屏显示内容" prepend-icon="$vuetify.icons.audio" v-model="form.ledDatas" :disabled="disabledFlag"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-btn flat color="primary" @click="addSubDevice" :disabled="disabledFlag">添加虚拟控制器</v-btn>
          </v-layout>
          <v-card class="mt-3 pa-3" v-for="(d,i) in form.subDeviceList" :key="i">
            <v-layout column>
              <v-layout>
                <v-spacer></v-spacer>
                <v-btn flat color="error" @click="deleteSubDevice(i)" :disabled="disabledFlag">删除</v-btn>
              </v-layout>
              <v-layout>
                <v-flex xs6>
                  <v-text-field label="控制器名称" prepend-icon="$vuetify.icons.title" v-model="d.name" :disabled="disabledFlag"></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-text-field label="序列号" prepend-icon="$vuetify.icons.title" v-model="d.sn" :disabled="disabledFlag"></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-btn color="primary" flat @click="autoGenerateSubDeviceSn(i)">自动生成</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs6>
                  <v-select label="控制类型" prepend-icon="$vuetify.icons.location" :items="d.typeSelect" v-model="d.ctrlType"></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select label="关联卡口" prepend-icon="$vuetify.icons.parkingLot" :items="form.dirGateList" v-model="d.gate"
                            item-text="name" item-value="id"></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-textarea v-model="d.description" label="描述" prepend-icon="$vuetify.icons.comment" rows="1" auto-grow></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs6>
                  <v-radio-group mandatory row v-model="d.pictureUp" label="是否允许上传图片" prepend-icon="$vuetify.icons.lock">
                    <v-radio :value="true" label="允许"></v-radio>
                    <v-radio :value="false" label="不允许"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs2>
                  <v-text-field label="显示屏显示行数" prepend-icon="$vuetify.icons.code" v-model="d.ledRows" :disabled="disabledFlag"></v-text-field>
                </v-flex>
                <v-flex xs10 >
                  <v-text-field label="显示屏显示内容" prepend-icon="$vuetify.icons.audio" v-model="d.ledDatas" :disabled="disabledFlag"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout column>
                <v-layout>
                  <v-flex xs6>
                    <v-text-field label="摄像头驱动" prepend-icon="$vuetify.icons.audio" v-model="d.cameraDriver"></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-btn flat color="primary" :disabled="disabledFlag" @click="addCameraIp(i)">添加CameraIp</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout v-for="(c,index) in d.cameraIp" :key="index">
                  <v-flex xs5>
                    <v-text-field label="ip" v-model="c.ip" prepend-icon="$vuetify.icons.code" :disabled="disabledFlag"></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-select label="type" :items="c.typeSelect" v-model="c.type" prepend-icon="$vuetify.icons.code" :disabled="disabledFlag"></v-select>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn flat color="error" @click="deleteCameraIp(i,index)">删除</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-card>
        </v-layout>
        <v-layout justify-center>
          <v-btn class="primary" @click="submit" :loading="loading" :disabled="disabledFlag">提交</v-btn>
        </v-layout>
      </v-card>
    </v-form>
  </l-layout>
</template>

<script>
    export default {
      name: "newIotDevice",
      data(){
          return {
            disabledFlag:false,
            loading:false,
            form:{
              name:'',
              description:'',
              sn:'',
              secret:'',
              subDeviceList:[],
              gate:"",
              service:"",
              dirGateList:[],
              ledRows:"2",
              ledDatas:"欢迎光临|旅途愉快"
            }
          }
      },
      methods:{
        async autoGenerateSn(){
          let res = await this.$store.dispatch('iot/autoGenerateSn')
          console.log(res)
          if(res.data.status+'' === '200'){
            this.form.sn = res.data.data
          }else{
            this.$L.alert('error',{message:'生成失败，原因:'+res.data.msg})
          }
        },
        async autoGenerateSubDeviceSn(idx){
          let res = await this.$store.dispatch('iot/autoGenerateSn')
          if(res.data.status+'' === '200'){
            this.form.subDeviceList[idx].sn = res.data.data
          }else{
            this.$L.alert('error',{message:'生成失败，原因:'+res.data.msg})
          }
        },
        async autoGenerateSecret(){
          let res = await this.$store.dispatch('iot/autoGenerateSecret')
          console.log(res)
          if(res.data.status+'' === '200'){
            this.form.secret = res.data.data
          }else{
            this.$L.alert('error',{message:'生成失败，原因:'+res.data.msg})
          }
        },
        async getGateByName (val) {
          try {
            let {items} = await this.$store.dispatch('park/getUnDirControllerList', {
              pagination: {page: 1, rowsPerPage: 100},
              search: {key: 'name', value: val},
            })
            return items
          }
          catch (e) {
            this.$L.alert('error', {message: e.message})
            return []
          }
        },
        async getServiceByName (val) {
          try {
            let {items} = await this.$store.dispatch('iot/getServiceList', {
              pagination: {page: 1, rowsPerPage: 100},
              search: {key: 'name', value: val},
            })
            return items
          }
          catch (e) {
            this.$L.alert('error', {message: e.message})
            return []
          }
        },
        addSubDevice(){
          let obj = {
            name:"",
            description:"",
            gate:"",
            pictureUp:true,
            sn:"",
            ledRows:"2",
            ledDatas:"欢迎光临|旅途愉快",
            cameraDriver:"",
            ctrlType:"",
            typeSelect:[
              "in",
              "out"
            ],
            cameraIp:[]
          }
          this.form.subDeviceList.push(obj)
        },
        addCameraIp(index){
          this.form.subDeviceList[index].cameraIp.push({
            ip:"",
            type:"",
            typeSelect: [
              "in",
              "out"
            ]
          })
        },
        deleteCameraIp(i,index){
          this.form.subDeviceList[i].cameraIp.splice(index,1)
        },
        deleteSubDevice(i){
          this.form.subDeviceList.splice(i,1)
        },
        async submit(){
          if(this.$refs.deviceForm.validate()){
            let subDeviceList = []
            for(let i=0;i<this.form.subDeviceList.length;i++){
              let s = this.form.subDeviceList[i]
              let cameraIp = []
              for(let j=0;j<s.cameraIp.length;j++){
                let c = {
                    "ip":s.cameraIp[j].ip,
                    "type":s.cameraIp[j].type
                  }
                  cameraIp.push(c)
              }
              for(let j=0;j<this.form.dirGateList.length;j++){
                console.log(this.form.dirGateList[j])
                if(s.gate === this.form.dirGateList[j].id){
                  console.log("找到匹配的入口id, 此时有向卡口的entranceId为：" + this.form.dirGateList[j].entranceId)
                  s.sn = this.form.dirGateList[j].entranceId
                  break
                }
              }
              let obj = {
                "name":s.name,
                "sn":s.sn,
                "dirgateId":s.gate,
                "pictureUp":s.pictureUp,
                "ledRows":s.ledRows,
                "cameraIp":cameraIp,
                "ledDatas":s.ledDatas,
                "ctrlType":s.ctrlType,
                "cameraDriver":s.cameraDriver
              }
              subDeviceList.push(obj)
            }
            let params = {
              "name":this.form.name,
              "description":this.form.description,
              "sn":this.form.sn,
              "secret":this.form.secret,
              "gateId":this.form.gate.id,
              "access_protocol":"websocket",
              "net_type":"CELLULAR",
              "property":[
                {
                  "name":"memory",
                  "description":"内存",
                  "value":"10MB"
                },
                {
                  "name":"disk",
                  "description":"磁盘存储",
                  "value":"100MB"
                },
                {
                  "name":"temperature",
                  "description":"温度",
                  "value":"60℃"
                },
                {
                  "name":"humidity",
                  "description":"湿度",
                  "value":"90%RH"
                },
                {
                  "name":"semaphore",
                  "description":"信号量",
                  "value":"30%"
                }
              ],
              "subDevice":subDeviceList,
              "entend":{
                "ledRows":this.form.ledRows,
                "ledDatas":this.form.ledDatas
              },
              "bizsrvId":this.form.service.id
            }
            this.loading = true
            try {
              let res = await this.$store.dispatch('iot/addDevice',params)
              if(res.data.status+''==='200'){
                this.$L.alert('success',{message:'添加成功'})
                this.disabledFlag = true
              }else{
                this.$L.alert('error',{message:'添加失败，原因：'+res.data.msg})
              }
            }catch (e) {
              console.log(e)
            }finally {
              this.loading = false
            }
          }else{
            this.$L.alert('error',{message:'表单数据不合法'})
          }
        }
      },
      watch:{
          'form.gate'(){
            if(this.form.gate!==null&&this.form.gate!==''){
              this.form.dirGateList = this.form.gate.dirgateList
              this.form.sn = this.form.gate.sn
            }
          }
      }
    }
</script>

<style scoped>

</style>
